/**
 * Module to load Intercom's api and to configure it
 * You can use intercom in the rest of the app by:
 *  require $intercom
 *  use $intercom.$trackEvent (will apply scope) or $intercom.trackEvent (will NOT apply scope)
 */
angular.module('bbl.services.intercom', ['ngIntercom'])

  .config(['$intercomProvider', 'INTERCOM_ID', function($intercomProvider, intercomId) {
    // provide intercom app id
    $intercomProvider.appID(intercomId);

    // load intercom script async
    $intercomProvider.asyncLoading(true);
  }])

  .run(['Auth', 'pubsub', '$intercom', '$cookies', function(Auth, pubsub, $intercom, $cookies) {
    var bootIc = function bootIc(user) {
      if ($cookies.get('impersonating')) {
        console.log('impersonating, skipping intercom');
        return;
      }

      var userPlan = user.plan || {}, company = user.company || {};

      $intercom.boot({
        email: user.username,
        user_id: user.id,
        name: user.first_name + " " + user.last_name,

        plan_name : userPlan.name,
        plan_description : userPlan.description,
        plan_status : company.status,
        allotted_minutes : company.minutes_in_package,
        minutes_used: company.total_minutes_used,
        bonus_minutes: company.bonus_minutes,

        companies: [{
          name: company.name,
          company_name: company.name,
          company_id: company.id,
          stripe_customer_id: company.customer_id,
          monthly_spend: userPlan.price,
          plan : userPlan.description,
          plan_status: company.status,
          allotted_minutes : company.minutes_in_package,
          minutes_used : company.total_minutes_used,
          bonus_minutes : company.bonus_minutes
        }]
      });

      return user;
    };

    pubsub.sub(Auth.evTypes.LOGGED_IN, function(ev, data) {
      Auth.getUserInfo().then(bootIc).catch(angular.noop);
    });

    Auth.getUserInfo().then(bootIc).catch(angular.noop);
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/intercom-service.js
 ** module id = 159
 ** module chunks = 0
 **/